import React from 'react';

import 'twin.macro';
import { CJAtelier } from 'types/cj';
import SmallCards from 'components/RadioGroups/SmallCards';
import FormGroup from 'components/Form/FormGroup';
import { useTranslation } from 'react-i18next';

interface Props {
  atelier: CJAtelier;
  onChange: (atelier: CJAtelier) => void;
}

export function SupervisionEditor(props: Props) {
  const { atelier, onChange } = props;
  const { t } = useTranslation(['cahierJournal']);

  return (
    <div tw="space-y-4 py-4">
      <FormGroup label={t('cahierJournal:ateliers.encadrement')}>
        <SmallCards
          size="xs"
          wrap
          value={atelier.supervision}
          options={[
            {
              value: 'Dirigé',
              title: t('cahierJournal:ateliers.encadrement.dirige'),
            },
            {
              value: 'Semi-dirigé',
              title: t('cahierJournal:ateliers.encadrement.semiDirige'),
            },
            {
              value: 'Autonomie',
              title: t('cahierJournal:ateliers.encadrement.autonomie'),
            },
          ]}
          onChange={s => {
            onChange({
              ...atelier,
              supervision: s,
            });
          }}
        />
      </FormGroup>
    </div>
  );
}
